import { UserRights, UserRightType } from '../../../../entities/User'
import { useAuth } from '../useAuth/useAuth'

export const useAuthUserRightCheck = (
    right: keyof UserRights,
    rightType: UserRightType
) => {
    const { authUser } = useAuth()

    return authUser?.rights?.[right] === rightType
}
